import { render, staticRenderFns } from "./ComprarPack.vue?vue&type=template&id=12a267b6"
import script from "./ComprarPack.vue?vue&type=script&lang=js"
export * from "./ComprarPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports